class HayCalculations {
  estimateBaleWeight = (
    material: string,
    shape: string,
    dimensions: any,
    compressionRate: string,
    moisturePercentage: string
  ) => {

    // Convert dimensions ft -> m
    dimensions = Object.entries(dimensions)
      .map(([key, value]: any) => {
        return { [key]: parseFloat((value * 0.3048).toFixed(1)) };
      })
      .reduce((acc, curr) => ({ ...acc, ...curr }), {});

    const newMoisture = parseInt(moisturePercentage);
    const baseDensity = this.calculateDensity(material, compressionRate, shape);
    const adjustedDensity = baseDensity * (1 + newMoisture / 100);

    let volume;
    if (shape === "ssquare" || shape === "lsquare" || shape === "square") {
      const { length = 0, width = 0, height = 0 } = dimensions;
      volume = length * width * height;
    } else if (shape === "round") {
      const { diameter = 0, width = 0 } = dimensions;
      const radius = diameter / 2;
      volume = Math.PI * Math.pow(radius, 2) * width;
    } else {
      throw new Error("Invalid shape. Choose 'square' or 'round'.");
    }

    // Convert volumne m3 -> ft3
    const volumeInFt3 = volume * 35.3147;
    // Final weight (kg)
    return volumeInFt3 * adjustedDensity;
  };

  reEstimateBaleWeight = (
    baseDensity: string,
    shape: string,
    dimensions: any,
    moisturePercentage: string
  ) => {
    dimensions = Object.entries(dimensions)
      .map(([key, value]: any) => {
        return { [key]: (value * 0.3048).toFixed(1) };
      })
      .reduce((acc, curr) => ({ ...acc, ...curr }), {});

    const newMoisture = parseInt(moisturePercentage);
    const adjustedDensity =
      (Number(baseDensity)) * (1 + newMoisture / 100);

    let volume;
    if (shape === "ssqaure" || shape === "lsquare" || shape === "square") {
      const { length = 0, width = 0, height = 0 } = dimensions;
      volume = length * width * height;
    } else if (shape === "round") {
      const { diameter = 0, width = 0 } = dimensions;
      const radius = diameter / 2;
      volume = Math.PI * Math.pow(radius, 2) * width;
    } else {
      throw new Error("Invalid shape. Choose 'square' or 'round'.");
    }

    // Convert volumne m3 -> ft3
    const volumeInFt3 = volume * 35.3147;
    // Final weight (kg)
    return volumeInFt3 * adjustedDensity;
  };

  reEstimateDensity = (
    shape: string,
    dimensions: any,
    weight_per_bale: string // kg
  ) => {
    let volume_m3;
    if (shape === "ssquare" || shape === "lsquare" || shape === "square") {
      const { length = 0, width = 0, height = 0 } = dimensions;
      volume_m3 = length * width * height;
    } else if (shape === "round") {
      const { diameter = 0, width = 0 } = dimensions;
      const radius = diameter / 2;
      volume_m3 = Math.PI * Math.pow(radius, 2) * width;
    } else {
      throw new Error("Invalid shape. Choose 'square' or 'round'.");
    }

    const volume_ft3 = volume_m3 * 35.3147; // m3 -> ft3
    const density_kg_per_ft3 = parseFloat(weight_per_bale) / volume_ft3;

    // kg/m^3
    return density_kg_per_ft3;
  };

  calculateDensity = (
    material: string,
    compressionRate: string,
    shape: string
  ) => {

    // DENSITY TABLE (unit: kg/m^3)
    const densityTable: any = {
      alfalfa_hay: {
        rectangular: {
          loose: 90,
          medium: 130,
          high: 170,
        },
        round: {
          loose: 80,
          medium: 120,
          high: 160,
        },
      },
      grass_hay: {
        rectangular: {
          loose: 80,
          medium: 120,
          high: 160,
        },
        round: {
          loose: 70,
          medium: 110,
          high: 150,
        },
      },
      straw: {
        rectangular: {
          loose: 50,
          medium: 80,
          high: 120,
        },
        round: {
          loose: 40,
          medium: 70,
          high: 100,
        },
        square: {
          loose: 50,
          medium: 80,
          high: 120,
        }
      },
    };

    const newShape = shape == 'ssquare' || shape == 'lsquare' ? 'rectangular' : shape;
    if (
      !densityTable[material] ||
      !densityTable[material][newShape] ||
      !densityTable[material][newShape][compressionRate]
    ) {
      throw new Error(
        "Invalid material, shape, or compression rate. Please choose valid options."
      );
    }
    // CHANGE FROM kg/m3 -> kg/ft3
    return densityTable[material][newShape][compressionRate] * 0.02831;
  };
}

const instance = new HayCalculations();
export default instance;
